import { useState, type ReactNode } from 'react'
import { Box, IconButton, Popover, Stack, Typography } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'

type Props = { title: string; informationLabel?: string; children: ReactNode; wide?: boolean }

export default function PortfolioInfoPopup({ title, informationLabel, children, wide = false }: Props) {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null)
  const label = informationLabel ?? `${title} information`
  return (
    <>
      <IconButton
        size="small"
        aria-label={label}
        aria-haspopup="dialog"
        aria-expanded={Boolean(anchor)}
        onClick={event => {
          event.stopPropagation()
          setAnchor(event.currentTarget)
        }}
        sx={{ color: 'text.secondary' }}
      >
        <InfoOutlinedIcon sx={{ fontSize: 18 }} />
      </IconButton>
      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          role: 'dialog',
          'aria-label': label,
          sx: {
            p: 2,
            mt: 1,
            width: wide ? 620 : 380,
            maxWidth: 'calc(100vw - 32px)',
            borderRadius: 3,
          },
        }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1} mb={1}>
          <Typography variant="subtitle1" fontWeight={800}>
            {title}
          </Typography>
          <IconButton size="small" aria-label="Close information" onClick={() => setAnchor(null)}>
            <CloseRoundedIcon fontSize="small" />
          </IconButton>
        </Stack>
        <Box>{children}</Box>
      </Popover>
    </>
  )
}
